import {
    NOTIFICATION,
} from "Actions/notification";

const initialState = {
    notification: { open: false, msg: '' }
};
let payload = {}

export function notification(state = initialState, action) {
    switch (action.type) {
        case NOTIFICATION:
            payload = action.payload

            return {
                ...state,
                ...payload
            }
        default:
            return state;
    }
}
